// GJ20250104: Dropdown functionality in the menu drawer
document.addEventListener("DOMContentLoaded", function() {
  var dropdownToggles = document.querySelectorAll('.mydropdown-toggle');

  dropdownToggles.forEach(function(toggle) {
    // Prevent native <details> toggling
    toggle.addEventListener('click', function(event) {
      event.preventDefault();

      // Find the associated dropdown menu
      //var dropdownMenu = toggle.querySelector('.mydropdown-menu');
      var dropdownMenu = this.nextElementSibling;

      // Toggle 'show' class on the dropdown menu
      if (!dropdownMenu.classList.contains('show')) {
        openDropdown(dropdownMenu);
      } else {
        closeDropdown(dropdownMenu);
      }
    });
  });

  // Function to open the dropdown smoothly
  function openDropdown(menu) {
    // Set the max height first for smooth height transition
    menu.style.maxHeight = '500px';

    // Add 'show' class after a short delay to synchronize with CSS transition
    setTimeout(function() {
      menu.classList.add('show');
    }, 100); // Match this timeout with the CSS transition duration
  }

  // Function to close the dropdown smoothly
  function closeDropdown(menu) {
    // Reset styles for closing animation
    menu.style.maxHeight = '0';

    // Remove 'show' class after animation completes
    setTimeout(function() {
      menu.classList.remove('show');
    }, 200); // Match this timeout with the CSS transition duration
  }

  // Close the dropdown if clicked outside
  document.addEventListener('click', function(event) {
    var dropdownMenus = document.querySelectorAll('.mydropdown-menu');

    dropdownMenus.forEach(function(menu) {
      if (menu.classList.contains('show') && !event.target.closest('.mydropdown-toggle')) {
        closeDropdown(menu);
      }
    });
  });
});